export default {
  name: 'prelude2',
  data: function() {
    return {

    }
  },
  props: ['landingText'],
  methods: {
    goToNext: function() {
      this.$emit('change-component', 'prelude3-component')
    },
    checkAnswers: function(answers) {}
  },
  beforeMount: function() {

  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/prelude2/prelude2.js